import axios from 'axios'
import { Message } from 'element-ui'
import cuda from '@/utils/checkCuda'

const comfyUiUrl = ['https://u680646-erl9-dd9fb7e3.westd.seetacloud.com:8443', 'https://uu680646-erl9-dd9fb7e3.westd.seetacloud.com:8443']

let lastUsedBaseUrl = ''
let currentCudaIndex = ''
export const getLastUsedBaseUrl = () => {
  return lastUsedBaseUrl
}

// 返回 WebSocket 协议的 URL（https -> wss, http -> ws）
export const getWebSocketUrl = () => {
  return lastUsedBaseUrl.replace(/^https:/, 'wss:').replace(/^http:/, 'ws:')
}

// 返回cuda对应的编号
export const cudaIndexNum = () => {
  return currentCudaIndex
}

// ComfyUI后台服务
const request = axios.create({
  baseURL: '',
  timeout: 5000,
  headers: {
    'Content-Type': 'application/json'
  }
})

// 添加请求拦截器
request.interceptors.request.use(async function (config) {
  try {
    // 先从服务器拉取CUDA状态
    const res = await cuda.cudaCurrentStatus()
    const tempCuda = []
    for (const item in res) {
      if (res[item]['status'] === 'leisure') {
        const cuda = Number(item.split('cuda')[1])
        tempCuda.push(cuda)
      }
    }
    if (tempCuda.length > 0) {
      const cudaIndex = Number(tempCuda[0])
      cuda.changeCudaCurrentStatus(`cuda${cudaIndex}`, 'running')
      // 匹配预设的cuda列表
      cuda.cudaApi.forEach(item => {
        if (item[cudaIndex]) {
          config.baseURL = item[cudaIndex]
          lastUsedBaseUrl = config.baseURL
          currentCudaIndex = `cuda${cudaIndex}`
        }
      })
    } else {
      Message.warning('😥当前后台任务过多,正在排队进行,请耐心等待...')
      // 从数组中随机选择一个URL
      const randomIndex = Math.floor(Math.random() * comfyUiUrl.length)
      config.baseURL = comfyUiUrl[randomIndex]
      lastUsedBaseUrl = config.baseURL
      currentCudaIndex = `cuda${randomIndex}`
    }
  } catch (error) {
    // 从数组中随机选择一个URL
    const randomIndex = Math.floor(Math.random() * comfyUiUrl.length)
    config.baseURL = comfyUiUrl[randomIndex]
    lastUsedBaseUrl = config.baseURL
    currentCudaIndex = `cuda${randomIndex}`
  }

  // 设置超时时间
  config.timeout = 10000 // 增加到10秒
  console.log(`📡 配置完成，baseURL: ${config.baseURL}`)

  return config
}, function (error) {
  // 对请求错误做些什么
  console.error('🚨 请求拦截器错误:', error)
  return Promise.reject(error)
})

//  添加响应拦截器
request.interceptors.response.use(response => {
  if (response.status && response.status !== 200) {
    console.error('response', response)
    throw new Error('服务错误')
  }

  return response.data
}, async error => {
  // 详细的错误信息输出
  console.error('💱 完整错误信息:', {
    message: error.message,
    code: error.code,
    response: error.response?.status,
    hasResponse: !!error.response,
    baseURL: error.config?.baseURL,
    url: error.config?.url
  })
  // 打印服务器返回的详细错误信息
  if (error.response && error.response.data) {
    console.error('📋 服务器返回的错误详情:', JSON.stringify(error.response.data, null, 2))
  }
  const { response } = error
  if (response && response.status >= 400) {
    console.error('⚠️ 服务器错误:', response.status)
    await cuda.changeCudaCurrentStatus(currentCudaIndex, 'leisure')
    Message.error(`🚨 服务器不可用（HTTP ${response.status}）\n请检查ComfyUI是否正常运行`)
  } else if (error.code === 'ENOTFOUND' || error.code === 'ECONNREFUSED' || error.code === 'ECONNABORTED') {
    console.error(`🛑 无法连接ComfyUI服务器(${lastUsedBaseUrl})\n错误代码: ${error.code}`)
    Message.error(`🛑 无法连接ComfyUI服务器
URL: ${lastUsedBaseUrl}
错误: ${error.code}

请检查:
1. ComfyUI业务是否在线
2. 云端事例是否正常运行
3. 网络連接是否正常`)
  } else if (!window.navigator.onLine) {
    console.error('🛑 你的本地网络已断开')
    await cuda.changeCudaCurrentStatus(currentCudaIndex, 'leisure')
    Message.error('🛑 网络已断开，请检查你的网络连接')
  } else {
    console.error('🛑 未知的网络错误:', error.message)
    Message.error(`🛑 网络错误: ${error.message}\n请查看浏览器控制台了解触情`)
  }
  return Promise.reject(error)
})

export default request
